<form [formGroup]="form" class="form-horizontal" autocomplete="off" novalidate>
  <app-translation-options
    [defaultLanguage]="defaultLanguage"
    [additionalLanguages]="additionalLanguages"
    (openedTranslation)="onOpenedTranslation($event)"
    *ngIf="!createMode && additionalLanguages.length > 0"
  ></app-translation-options>

  <!-- Name -->
  <div class="form-group">
    <label class="col-md-4 control-label">
      <span class="required" [hidden]="viewMode">*</span> {{ 'NAME' | translate }}
    </label>
    <div class="col-md-8">
      <div [hidden]="!viewMode" class="form-label">
        {{ whatToBring.name }}
      </div>
      <div [hidden]="viewMode">
        <input type="text" class="form-control" formControlName="name" maxlength="100" />
        <app-form-errors
          [control]="form.controls['name']"
          [formSubmited]="formSubmited"
        ></app-form-errors>
        <app-form-server-errors [error]="serverErrors['name']"></app-form-server-errors>
      </div>
    </div>
  </div>

  <!-- Description -->
  <div class="form-group">
    <label class="col-md-4 control-label">{{ 'DESCRIPTION' | translate }}</label>
    <div class="col-md-8">
      <div [hidden]="!viewMode" class="form-label">
        {{ whatToBring.description || '-' }}
      </div>
      <div [hidden]="viewMode">
        <textarea class="form-control" formControlName="description" rows="2"></textarea>
      </div>
    </div>
  </div>

  <!-- Type -->
  <div class="form-group">
    <label class="col-md-4 control-label">
      <span class="required" [hidden]="viewMode">*</span> {{ 'TYPE' | translate }}
    </label>
    <div class="col-md-8">
      <ul class="list-unstyled control-list">
        <li>
          <label class="control control-checkbox">
            <input
              type="checkbox"
              [checked]="allProductTypesChecked"
              (click)="checkAllProductTypes($event)"
              [disabled]="viewMode"
            />
            <span>{{ 'CHECK_ALL' | translate }}</span>
            <div class="control-indicator control-inverse"></div>
          </label>
        </li>
        <li
          formArrayName="type"
          *ngFor="let productType of productTypesFormArray.controls; let i = index"
        >
          <label class="control control-checkbox">
            <input type="checkbox" [formControlName]="i" (change)="checkProductType($event)" />
            <span
              ><i class="fa fa-{{ productTypes[i].icon }}"></i>
              {{ productTypes[i].name | translate }}</span
            >
            <div class="control-indicator control-inverse"></div>
          </label>
        </li>
      </ul>
    </div>
  </div>

  <div class="form-actions no-wrap">
    <app-item-detail-form-actions
      [createMode]="createMode"
      [disableSaveItem]="sendingForm"
      [isModal]="isModal"
      [sendingForm]="sendingForm"
      [viewMode]="viewMode"
      (canceled)="onCanceled()"
      (edited)="onEditedWhatToBring()"
      (saved)="onSavedWhatToBring()"
    >
    </app-item-detail-form-actions>
  </div>
</form>
